import { FormGroup } from '@angular/forms';
import { EditorContainerConfig, EditorHelperService } from '@fleet-beat/editor';
import { OnDestroyMixin } from '@w11k/ngx-componentdestroyed';

export abstract class BaseEditorService<
  Input extends object | void,
  Form extends object,
  Output extends object,
> extends OnDestroyMixin {
  get form(): FormGroup {
    return this.formInner || (this.formInner = this.editorHelperService.createForm(this.config.editor));
  }

  abstract get config(): EditorContainerConfig<Input, Form, Output>;

  private formInner: FormGroup;

  protected constructor(protected editorHelperService: EditorHelperService) {
    super();
  }

  setInput(input: Input): void {
    const formValue: Input | Form = !input && this.config.convertToForm ? this.config.convertToForm(input) : input;
    this.form.reset(formValue || {});
  }

  setForm(form: Form): void {
    this.form.reset(form || {});
  }

  getOutput(): Output {
    const outputValue: Output = this.config.convertToOutput
      ? this.config.convertToOutput(this.form.value)
      : this.form.value;
    return outputValue;
  }

  protected convertToForm(input: Input): Form {
    return input as unknown as Form;
  }

  protected convertToOutput(form: Form): Output {
    return form as unknown as Output;
  }
}
